import { __assign, __rest } from "tslib";
export function mergeable(_a) {
    var _b = _a.headColSpan, headColSpan = _b === void 0 ? function () { return undefined; } : _b, _c = _a.colSpan, bodyColSpan = _c === void 0 ? function () { return undefined; } : _c, _d = _a.rowSpan, bodyRowSpan = _d === void 0 ? function () { return undefined; } : _d;
    return {
        getInfo: function () { return ({ name: "mergeable" }); },
        onInjectColumn: function (previous) { return function (record, rowKey, recordIndex, column, columnIndex) {
            var _a = previous(record, rowKey, recordIndex, column, columnIndex), prevProps = _a.props, result = __rest(_a, ["props"]);
            var colSpan;
            var rowSpan;
            if (recordIndex === -1) {
                var col = headColSpan(columnIndex, { column: column });
                colSpan = typeof col === "number" ? col : undefined;
            }
            else {
                var col = bodyColSpan(columnIndex, recordIndex, {
                    record: record,
                    rowKey: rowKey,
                    column: column,
                });
                var row = bodyRowSpan(columnIndex, recordIndex, {
                    record: record,
                    rowKey: rowKey,
                    column: column,
                });
                colSpan = typeof col === "number" ? col : undefined;
                rowSpan = typeof row === "number" ? row : undefined;
            }
            var props = __assign(__assign({}, prevProps), { colSpan: colSpan,
                rowSpan: rowSpan });
            return __assign(__assign({}, result), { props: props });
        }; },
    };
}
//# sourceMappingURL=mergeable.js.map